import { ACTIVATE_LOADER, DE_ACTIVATE_LOADER } from "."

export const toggleLoader = (status) => {
    return {
        type: status ? ACTIVATE_LOADER : DE_ACTIVATE_LOADER
    }
}